<template>
  <div>
    <table
      class="unstriped hover boss-table"
    >
      <thead>
        <tr>
          <th class="boss-table-head-center">
            登録名
          </th>
          <th class="boss-table-head-center boss-update">
            登録日
          </th>
          <th class="boss-table-head-center boss-update">
            更新日
          </th>
          <th class="boss-table-head-center boss-operation">
            編集
          </th>
          <th class="boss-table-head-center boss-operation">
            削除
          </th>
          <th class="boss-table-head-center boss-operation">
            プレビュー
          </th>
          <th class="boss-table-head-center">
            <div class="pega-relative">
              公開状況
              <span
                v-tooltip="{ content: '「公開設定 ＞ 公開する面接情報」の設定が反映されます。'}"
                class="pega-circle small-right-top"
              >?</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(interview, i) in interviews"
          :key="i"
        >
          <td
            class="boss-table-data"
            data-test="interview-name"
          >
            {{ interview.name }}
          </td>
          <td
            class="boss-table-data text-center"
            data-test="interview-create-date"
          >
            {{ interview.createDate | formatDate }}
          </td>
          <td
            class="boss-table-data"
            data-test="interview-update-date"
          >
            {{ interview.updateDate | formatDate }}
          </td>
          <td class="boss-table-data">
            <button
              class="boss-icon-pencil"
              data-test="interview-edit"
              @click="$router.push({ name: 'interviewInformationEdit', params: { jobInterviewId: interview.id } })"
            />
          </td>
          <td
            class="boss-table-data"
            data-test="interview-remove"
            @click="doRemove(interview.id)"
          >
            <button class="boss-icon-trash" />
          </td>
          <td class="boss-table-data">
            <router-link
              class="boss-button pega-button boss-exe-button-center"
              :to="{ name: 'interviewInformationPreview', params: { jobInterviewId: interview.id } }"
              target="_blank"
            >
              <span class="boss-exe-button-text">面接情報</span>
            </router-link>
          </td>
          <td
            class="boss-table-data"
            data-test="is-published"
          >
            {{ interview.isPublished | publishLabel }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  filters: {
    formatDate (val) {
      return dayjs(val).format('YYYY/MM/DD')
    },
    publishLabel (val) {
      return val ? '公開中' : '非公開'
    }

  },
  props: {
    interviews: {
      type: Array,
      required: true
    }
  },
  methods: {
    removeInterview (id) {
      return this.$http.secured.put(`/interview/interviews/${id}/_closed`)
    },
    doRemove (id) {
      this.$dialog.confirm('削除しますか？')
        // はいを押下した時
        .then(() => {
          this.removeInterview(id) // 削除
            .then(() => {
              this.$toasted.global.success({ message: '面接情報を削除しました' })
              this.$emit('fetch') // 面接情報の再取得
            })
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    }
  }
}
</script>
